import React, {ReactElement, useState} from 'react'

import "styles/components/popup.sass"
import "pages/Styles/UIKit.sass"

import {CircularProgress} from "@mui/material";
import {CopyToClipboard} from "react-copy-to-clipboard";
import Popup from "../../../components/Popup";
import notifyUser from "../../../methods/notifyUser";
import {connect} from "react-redux";
import TextArea from "../../../components/elements/TextArea";
import {ReactComponent as Copy} from "../../Icons/size24/Copy.svg";
import TemplateIntegrationSettings, {IntegrationType} from "../../../components/TemplateIntegrationSettings";

type Props = {
    serviceName: string,
    helpView: ReactElement,
    close: Function,
    realtyConfig: any,
    $store: any,
    $commitToStore: Function,
}

let IncomingWebhookIntegrationPopup: any = function IntegrationPopup(props: Props) {
    const [loading, setLoading] = useState(false)
    const realtyConfig = props.$store.userSession?.realty_integration
    const isNewIntegrationEnabled = realtyConfig && realtyConfig.integration_type === 3

    function onCopy() {
        notifyUser(props, `Ссылка скопирована. Теперь вставьте ее в настройках ${props.serviceName}`);
    }

    function link() {
        return `https://api.doki.online/webhook/${props.$store.userSession.realty_api_key}`
    }

    function IntegrationUrlView({ serviceName, apiKey, onCopy }: { serviceName: string, apiKey: string, onCopy: () => void }) {
        return <div>
            <hr className="newHR"/>
            <div className="titleContainer" style={{marginTop: "15px", gap: "20px"}}>
                <div className="commonLabel" style={{width: "100%"}}>
                    <TextArea
                        style={{
                            marginTop: "10px",
                        }}
                        readOnly
                        value={link()}
                        onChange={() => {}}
                    />
                    <CopyToClipboard
                        onCopy={() => {
                            onCopy()
                        }}
                        text={link()}
                    >
                        <button className="new withTitle _wa" style={{marginTop: "15px"}}>
                            <div className="buttonsContainer">
                                <Copy className="icon" style={{fill: "white"}}/>
                                <span>Скопировать строку</span>
                            </div>
                        </button>
                    </CopyToClipboard>
                </div>
            </div>
        </div>
    }


    return <Popup
        maxWidth="650px"
        onClose={() => {
            props.close()
        }}
    >
        <div>
            {
                props.helpView
            }
            {props.serviceName === "RealtyCalendar" && (
                <>
                    {isNewIntegrationEnabled && (
                        <div style={{
                            background: "#f8d7da",
                            border: "1px solid #f5c6cb",
                            borderRadius: "8px",
                            padding: "16px",
                            marginBottom: "20px",
                            fontSize: "14px",
                            lineHeight: "1.5",
                            color: "#721c24"
                        }}>
                            <div style={{fontWeight: 600, marginBottom: "10px", display: "flex", alignItems: "center", gap: "8px"}}>
                                ⚠️ Новая интеграция RealtyCalendar 2.0 уже включена
                            </div>
                            <div style={{fontSize: "13px"}}>
                                Если вы хотите использовать старую интеграцию, необходимо <strong>удалить вебхук (ссылку) из настроек RealtyCalendar</strong> перед настройкой старой интеграции. 
                                Иначе обе интеграции будут работать одновременно, что может привести к дублированию договоров.
                            </div>
                        </div>
                    )}
                    <div style={{
                        background: "#fff3cd",
                        border: "1px solid #ffeaa7",
                        borderRadius: "8px",
                        padding: "16px",
                        marginTop: "15px",
                        marginBottom: "20px",
                        fontSize: "14px",
                        lineHeight: "1.5",
                        color: "#856404"
                    }}>
                        <div style={{fontWeight: 600, marginBottom: "10px", display: "flex", alignItems: "center", gap: "8px"}}>
                            ⚠️ Это старая интеграция
                        </div>
                        <div style={{marginBottom: "12px"}}>
                            Рекомендуем перейти на новую интеграцию <strong>RealtyCalendar 2.0</strong>, которая предоставляет больше возможностей:
                        </div>
                        <ul style={{margin: "0 0 12px 18px", padding: 0, fontSize: "13px"}}>
                            <li>Работа с договорами прямо из личного кабинета RealtyCalendar</li>
                            <li>Отслеживание статусов подписания в реальном времени</li>
                            <li>Улучшенная синхронизация данных</li>
                        </ul>
                        <div style={{fontSize: "13px"}}>
                            Закройте это окно и выберите <strong>"RealtyCalendar 2.0"</strong> в списке интеграций для перехода на новую версию.
                        </div>
                    </div>
                </>
            )}
            <hr className="newHR"/>
            <div className="Body_15" style={{textAlign: "left"}}>
                {`Чтобы настроить интеграцию с ${props.serviceName} - скопируйте ссылку ниже и вставьте ее в соответствующий раздел в настройках ${props.serviceName}`}
            </div>
            
            <TemplateIntegrationSettings
                serviceName={props.serviceName}
                placeholderText={`Введите номер лота из ${props.serviceName}`}
                integrationConfig={props.realtyConfig}
                integrationFieldName="realty_integration"
                idFieldName="realty_id"
                $store={props.$store}
                $commitToStore={props.$commitToStore}
            />

            <IntegrationUrlView
                serviceName={props.serviceName}
                apiKey={props.$store.userSession.realty_api_key}
                onCopy={onCopy}
            />

            <hr className="newHR"/>
            <button
                className="new withTitle _wa"
                disabled={loading}
                style={{marginTop: "15px"}}
                onClick={() => {
                    props.close()
                }}
            >
                    <div className="buttonsContainer">
                        {
                            loading &&
                            <CircularProgress size={"25px"} sx={{color: "#1FA3EE"}} />
                        }
                        <span>Сохранить и закрыть</span>
                    </div>
                </button>
        </div>
    </Popup>
}

IncomingWebhookIntegrationPopup = connect(
    (store) => ({ $store: store }),
    (dispatch) => ({
        $commitToStore: (data: any) => dispatch({ ...data, type: 'S' })
    })
)(IncomingWebhookIntegrationPopup)

export default IncomingWebhookIntegrationPopup
